import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=493b58dc&"
import script from "./blogDetail.vue?vue&type=script&lang=js&"
export * from "./blogDetail.vue?vue&type=script&lang=js&"
import style0 from "./blogDetail.vue?vue&type=style&index=0&id=493b58dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports